define('editor/index',['durandal/app', 'plugins/router', 'jquery'], function(app, router, $) {
    var childRouter = router.createChildRouter().makeRelative({
        moduleId: 'editor',
        fromParent: true
    }).map([
        { route: ['', 'list'],  moduleId: 'list/index',         title: 'Map List' },
        { route: 'list/all',    moduleId: 'list/index',         title: 'Map List' },
        { route: 'new',         moduleId: 'metadata/index',     title: 'Create New Map' },
        { route: 'metadata',    moduleId: 'metadata/metadata',  title: 'Metadata' },
        { route: 'dialog',      moduleId: 'metadata/dialog',    title: 'Edit Map Metadata' },
        { route: 'edit/:id',    moduleId: 'edit/index',         title: 'Edit Map',               isEditor: true },
        { route: 'render/:id',  moduleId: 'render/index',       title: 'Render Map' },
        { route: 'render/:id',  moduleId: 'render/dialog',      title: 'Render Map' },
        { route: 'export/:id',  moduleId: 'export/index',       title: 'Export Map' }
    ]).buildNavigationModel();

    var viewmodel = function() {
        var self = this;
        self.router = childRouter;
        self.app = app;

        self.router.on('router:navigation:processing', function (instruction) {
            app.updateLayoutView(instruction.config.isEditor);
        });

        self.canActivate = function() {
            return true;
        };
    };
    return viewmodel;
});
